import React from "react";
import Movieapp from "./components/movieapp";

const App = () => {
  return(<Movieapp />) 
  
};

export default App;